import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import UpgradeRequestDialog from './UpgradeRequestDialog'

import styles from './UpgradePrompt.module.scss'

import { UPGRADE_PROMPT_FEATURES } from '@/constants/planFeatures'
import { selectIsAdmin, selectPlanType } from '@/store/features/user/userSlice'
import { PlanType } from '@/types'

const UpgradePrompt = () => {
  const [isVisible, setIsVisible] = useState(true)
  const [isRequestingUpgrade, setIsRequestingUpgrade] = useState(false)
  const navigate = useNavigate()
  const planType = useSelector(selectPlanType)
  const isAdmin = useSelector(selectIsAdmin)

  useEffect(() => {
    const dismissed = localStorage.getItem('upgradePromptDismissed')
    if (dismissed || planType === PlanType.Enterprise) {
      setIsVisible(false)
    }
  }, [planType])

  const handleDismiss = (e?: React.MouseEvent) => {
    e?.stopPropagation()
    localStorage.setItem('upgradePromptDismissed', 'true')
    setIsVisible(false)
  }

  const handleClick = () => {
    if (isAdmin) {
      navigate('/app/settings/billing')
    } else {
      setIsRequestingUpgrade(true)
    }
    handleDismiss()
  }

  return (
    <>
      {isVisible && (
        <div className={styles.upgradePrompt}>
          <div className={styles.content}>
            <div className={styles.title}>Upgrade to {PlanType.Enterprise}</div>
            <ul>
              {UPGRADE_PROMPT_FEATURES.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
            <button className={styles.upgradeButton} onClick={handleClick}>
              {isAdmin ? 'View Plans' : 'Request Upgrade'}
            </button>
          </div>
          <button className={styles.dismissButton} onClick={handleDismiss}>
            ✕
          </button>
        </div>
      )}
      <UpgradeRequestDialog isOpen={isRequestingUpgrade} onClose={() => setIsRequestingUpgrade(false)} />
    </>
  )
}

export default UpgradePrompt
